/*
  MIT License

  Copyright (c) 2018 Riad Loukili <rizoox@icloud.com>

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

import {h, Component} from 'preact'

import BottomTabs from '../BottomTabs'

export default class Wireframe extends Component {

  render() {
    return (
      <div style={{minHeight: '100vh'}}>
        <div style={{position: 'relative', height: this.props.tabsVisible ? 'calc(100vh - 56px)' : '100vh', overflowY: 'auto', overflowX: 'hidden', '-webkit-overflow-scrolling': 'touch'}}>
          {this.props.children}
        </div>
        { this.props.tabsVisible && <BottomTabs onChange={this.props.onTabsChange} currentPage={this.props.currentPage} /> }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/Wireframe/index.js